import React from 'react';
// import PropTypes from 'prop-types';
import { graphql, withApollo } from 'react-apollo';
import getCasoViolenciaPorId from '../../../../graphql/querys/violenciaGenero/getCasoViolenciaPorId.graphql';
import subirDocumento from '../../../../graphql/mutations/violenciaGenero/subirDocumento.graphql';
import agregarMedida from '../../../../graphql/mutations/violenciaGenero/agregarMedida.graphql';
import { Upload, Row, Col, Spin, Button, Input, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

@graphql(subirDocumento, {
  name: 'subirDocumento',
  options: {
    refetchQueries: [
      {
        query: getCasoViolenciaPorId,
        options: props => ({
          variables: {
            _id: props.caso._id,
          },
          fetchPolicy: 'network-only',
          onCompleted: data => {
            console.log('Estoy en...');
            console.log(data);
          },
          onError: data => {
            console.log('ERROR: ', data);
            console.log(props);
          },
        }),
      },
    ],
  },
})
@graphql(agregarMedida, {
  name: 'agregarMedida',
})
class Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      titulo: '',
      uploading: false,
    };
  }

  guardarActuacionEnServer = file => {
    this.props
      .subirDocumento({
        variables: {
          objDocumento: {
            nombre: this.state.titulo,
            tramite: 'caso_violencia',
            idTramite: this.props.caso._id,
          },
          archivo: file,
        },
      })
      .then(res => {
        if (res.data.subirDocumento) {
          console.log(res.data.subirDocumento);

          this.props
            .agregarMedida({
              variables: {
                _id: this.props.caso._id,
                idDocumento: res.data.subirDocumento._id,
              },
            })
            // eslint-disable-next-line no-unused-vars
            .then(resAgregarMedida => {
              this.props.ocultar();
              notification.success({
                message: 'Documento agregado correctamente',
                description:
                  'El documento se registró correctamente en la base de datos',
              });
            })
            .catch(err => {
              console.log('Error a la hora de agregar el documento al caso');
              console.log(err);
            });
        }
      })
      .catch(err => {
        console.log('ERROR EN INSERTAR ACTUACION: ', err);

        notification.error({
          message: 'Error al agregar el documento',
          description: 'Se ha producido un error al agregar el documento',
        });
      });
  };

  handleUpload() {
    const { fileList } = this.state;
    if (!fileList.length) return;

    if (this.state.titulo.length > 0) {
      let all = fileList.map(file => this.guardarActuacionEnServer(file));
      // eslint-disable-next-line no-unused-vars
      Promise.all(all).then(res => {
        this.setState({ uploading: false, fileList: [] });
        if (this.props.onDone) this.props.onDone(all);
      });
      this.setState({ uploading: true });
    } else {
      notification.warning({
        message: 'Debe incluir un titulo al archivo PDF',
      });
    }
  }

  render() {
    const uploadProps = {
      action: this.props.action || this.state.uploadData,
      // data: this.state.uploadData.formData,
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }));
        return false;
      },
      fileList: this.state.fileList,
      accept: 'application/pdf',
    };

    return (
      <Form encType="multipart/form-data">
        <Row>
          <Col span={24}>
            <div className="inputs">
              <h3>Titulo: </h3>
              <Input
                id="titulo"
                value={this.state.titulo}
                placeholder="Ingrese el titulo del documento a subir"
                onChange={e =>
                  this.setState({
                    titulo: e.target.value,
                  })
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Upload {...uploadProps}>
              <Button>
                <Icons.UploadOutlined />
                Seleccionar Documento PDF
              </Button>
            </Upload>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <br />
            {this.state.uploading && <Spin tip="Subiendo..." />}
            {!this.state.uploading && this.state.fileList.length > 0 && (
              <Button
                icon={<Icons.UploadOutlined />}
                onClick={this.handleUpload.bind(this)}
                style={{ width: '20em' }}
                type="primary"
              >
                Subir
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withApollo(Uploader);
